export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13577.d1c02b04.jpg";